import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import {WalletService} from "../../../services/wallet.services";
import { TranslationService } from '../../../services/translation.service';

declare let $: any;
declare let Swal: any;
declare var JitsiMeetExternalAPI;

@Component({
  selector : 'room-media-modal',
  templateUrl:'room-media-component.html'
})
export class RoomMediaControlComponent implements OnInit, OnDestroy{

  public ref;
  public api;
  public contacts=[]
  public hasmicrophone={}
  public microfone=false;
  public allSpeak=false;
  public allProximity=true;
  public allMute=false;
  public allProximityLessMe=false;
  public lockRoom='Trancar';
  public hasKey;


  public canChangeUsers=true;
  public canChangeVideo=true;
  public canChangeAudio=true;
  public canNotify=true;

  public constructor( private _router : Router,public _appData : AppDataService,private fb : FormBuilder, public translate: TranslationService,private _companyService : CompanyService, public _walletService: WalletService) {
    }
    public ngOnInit(): any {
    }
    public lock(){
          if (this._appData.room.locked){
            this._appData.room.locked=false;
            this.lockRoom='Trancar'
          }
          else{
            this._appData.room.locked=true;
            this.lockRoom='Destrancar'
          }
          this._companyService.updateRoom(this._appData.room); 
    }
    public makeKey(){
      if (this._appData.room.key){
        let vet=this._appData.eventRecipes.filter(v=>{
          return v.id=='1640530071119'
        })
        let rec=vet[0]
        let baseItem=rec.toItem()
        baseItem.name=this._appData.room.key
        Swal.fire({
          title: 'Transferindo',
          text: 'Aguarde enquanto a receita do item esta sendo criada',
          imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
          showConfirmButton: false
        })
        this._walletService.makeTokenTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',rec.tokenId,1,baseItem.toDB(),null,null,this._appData.instagramUser.uid,'user-container').subscribe(wa=>{
          Swal.close()
          this._appData.userEventContainer.push(baseItem);
          this.hasKey=true;
          Swal.fire("Chave feita","Chave feita e posta em sua mochila")
        },err=>{
          Swal.close()
          Swal.fire(this.translate.instant('FAIL'),'Ouve uma falha na criação do token para sua carteira. Tente de novo')
        }) 

      }
      else{
        $('#roomMediaControlModal').modal('hide');
        Swal.fire({
          title: 'Criar chave',
          text: 'Digite o nome da chave',
          input:'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'OK',
          showLoaderOnConfirm: true,
          preConfirm: (login) => {
          },
          allowOutsideClick: () => !Swal.isLoading()
        }).then ((result)=>{
          if (result.value){
            

            let vet=this._appData.eventRecipes.filter(v=>{
              return v.id=='1640530071119'
            })
            let rec=vet[0]
            let baseItem=rec.toItem()
            baseItem.name=result.value
            Swal.fire({
              title: 'Transferindo',
              text: 'Aguarde enquanto a receita do item esta sendo criada',
              imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
              showConfirmButton: false
            })
            this._walletService.makeTokenTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',rec.tokenId,1,baseItem.toDB(),null,null,this._appData.instagramUser.uid,'user-container').subscribe(wa=>{
              Swal.close()
              this._appData.userEventContainer.push(baseItem);
              this.hasKey=true;
              this._appData.room.key=result.value
              this.hasKey=true;
              this._companyService.getRoom(this._appData.room.id).set(this._appData.room);
              Swal.fire("Chave feita","Chave feita e posta em sua mochila") 
            },err=>{
              Swal.close()
              Swal.fire(this.translate.instant('FAIL'),'Ouve uma falha na criação do token para sua carteira. Tente de novo')
            }) 


          }
    
        })
  
      }
    }
    public microphone(contact){
      let uid=contact.uid;
      let microfone=contact.microfone;
      let microphones=this._appData.room.microphone;
      if (microfone){
        //need to remove form list if its there
        microphones=microphones.filter(v=>{
          return v!=uid;
        })
      }
      else{
        //need to add to the list if its not there;
        let f=microphones.filter(v=>{
          return v==uid;
        })
        if (f.length==0){
          microphones.push(uid);
        }       
      }
      for (let idx=0;idx<this.contacts.length;idx++){
          if (this.contacts[idx].uid==contact.uid){
            this.contacts[idx].microfone=!this.contacts[idx].microfone
          }
        }

        let baseVolume=0
        let voiceStatus=this._appData.room.voiceStatus
        if (voiceStatus==-1){
          baseVolume=0;
        }
        else if (voiceStatus==1){
          baseVolume=1;
        }
        else if (voiceStatus==0){
          baseVolume=-1;
        }
      let volume=-1;
      if (microfone){
        volume=baseVolume;
      }
      else{
        volume=1;
      }
      let messageKind={
        kind:'updateUserStatus',
        params:{uid:uid,volume:volume,room:this._appData.room.id,baseVolume:baseVolume}
      };
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");

      this._appData.room.microphone=microphones;
      this._companyService.updateRoom(this._appData.room)
     
    }
    public myMicrophone(microfone){
      let volume=1;
      let uid=this._appData.instagramUser.uid;
        if (microfone){
          volume=1
        }
        else{
          volume=-1;
        } 

      let messageKind={
        kind:'updateUserStatus',
        params:{uid:uid,volume:volume}
      };
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }
    public domute(){
      let volume=0;
      for (let idx=0;idx<this.contacts.length;idx++){
          if (this.contacts[idx].uid==this._appData.instagramUser.uid){
            this.contacts[idx].microfone=true
          }
          else{
            this.contacts[idx].microfone=false
          }
      }
      this.allMute=true
      this.allSpeak=false;
      this.allProximity=false;
      this.allProximityLessMe=false
      let date=new Date();
      let time=date.getTime();
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:this._appData.instagramUser.full_name,
        senderThumbnail:this._appData.instagramUser.profile_picture,
        subject:'Modo de Audio Alterado',
        message:this._appData.instagramUser.full_name+' alterou o audio da sala para que todos se silenciem',
        kind:'talkMode',
        link:{all:0,me:[this._appData.instagramUser.uid]},
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification);
      this._appData.room.voiceStatus=-1;
      this._appData.room.microphone=[this._appData.instagramUser.uid];
      this._companyService.updateRoom(this._appData.room);
    }
    public doVoiceAll(){
      for (let idx=0;idx<this.contacts.length;idx++){
        if (this.contacts[idx].uid==this._appData.instagramUser.uid){
          this.contacts[idx].microfone=true
        }
      }
      this.allMute=false
      this.allSpeak=true;
      this.allProximity=false;
      this.allProximityLessMe=false

      let date=new Date();
      let time=date.getTime();
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:this._appData.instagramUser.full_name,
        senderThumbnail:this._appData.instagramUser.profile_picture,
        subject:'Modo de Audio Alterado',
        message:this._appData.instagramUser.full_name+' alterou o audio da sala para que todos falem em qualquer lugar',
        kind:'talkMode',
        link:{all:1,me:[]},
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification);
      this._appData.room.voiceStatus=1;
      this._appData.room.microphone=[];
      this._companyService.updateRoom(this._appData.room);
    }
    public doProximity(microphone){
      for (let idx=0;idx<this.contacts.length;idx++){
        if (this.contacts[idx].uid==this._appData.instagramUser.uid){
          if (microphone){
            this.contacts[idx].microfone=true
          }
          else{
            this.contacts[idx].microfone=false
          }
        }
        else{
          this.contacts[idx].microfone=false
        }
      }
      this.allMute=false
      this.allSpeak=false;
      this.allProximity=!microphone;
      this.allProximityLessMe=microphone
      let date=new Date();
      let time=date.getTime();
      let mic=this._appData.room.mic;
      if (!mic) mic=[];
      if (microphone){
        mic.push(this._appData.instagramUser.uid)
      }
      else{
        mic=mic.filter(v=>{
          return v!=this._appData.instagramUser.uid
        })
      }
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:this._appData.instagramUser.full_name,
        senderThumbnail:this._appData.instagramUser.profile_picture,
        subject:'Modo de Audio Alterado',
        message:this._appData.instagramUser.full_name+' alterou o audio da sala para que todos falem por proximidade',
        kind:'talkMode',
        link:{all:-1,me:mic},
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification);
      this._appData.room.voiceStatus=0;
      this._appData.room.microphone=mic;
      this._companyService.updateRoom(this._appData.room);
     
    }
    public notify(){
      $('#roomMediaControlModal').modal('hide')
      Swal.fire({
        title: 'Notificação',
        text:'Escreva uma mensagem para notificar todos os usuários na sala. Você também pode embedar um vídeo caso queira colando abaixo a url embedada.',
        input: 'text',
        inputAttributes: {
        autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'ENTRAR',
        showLoaderOnConfirm: true,
      }).then((result) => {
      if (result.value) {
        let video=false;
        let text=result.value;
        if (text.indexOf('https')==0){
          video=true;
        }
        let notification;
        let date=new Date();
        let time=date.getTime();
        if (!video){
          notification={
            subject:'Notificação',
            message:text,
            kind:'text',
            date:time
          }
        }else{
          notification={
            subject:'Notificação',
            video:text,
            kind:'video',
            date:time
          }
        }
        this._companyService.addRoomNotification(this._appData.room,notification);
      }
    })

    }
    public onChange(): any {


      let item=this._appData.object;
      this._appData.object=null;

      if (item && item.action=='key'){
        //setup for key only
        this.canChangeUsers=false;
        this.canChangeVideo=false;
        this.canChangeAudio=false;  
        this.canNotify=false;
        if (item.param.master){
          this.canChangeUsers=true;
          this.canChangeVideo=true;
          this.canChangeAudio=true;  
          this.canNotify=true;
        }   
      }
      if (this._appData.instagramUser.uid=="T6sKpIAzwlPlYmEGgy2FuolQ2wN2"){
        this.canChangeUsers=true;
        this.canChangeVideo=true;
        this.canChangeAudio=true;  
        this.canNotify=true;
      }

      this.contacts=[]
      if (this.api){  
        this.api.dispose();
      }
      if (this.ref){
        this.ref.off();
      }
      let room=this._appData.room
      if (room){
        
        if (room.locked){
          this.lockRoom='Destrancar'
        }
        else{
          this.lockRoom='Trancar'
        }
        if (room.voiceStatus){
          if (room.voiceStatus==1){
            this.allMute=false
            this.allSpeak=true;
            this.allProximity=false;
            this.allProximityLessMe=false
            $("#allProximity").prop('checked',false);
            $("#allSpeak").prop('checked',true);
            $("#allMute").prop('checked',false);
            $("#allProximityLessMe").prop('checked',false);   
  
          }
          else{
            this.allMute=true
            this.allSpeak=false;
            this.allProximity=false;
            this.allProximityLessMe=false
            $("#allProximity").prop('checked',false);
            $("#allSpeak").prop('checked',false);
            $("#allMute").prop('checked',true);
            $("#allProximityLessMe").prop('checked',false);          
          }
        }
        else{
          this.allMute=false
          this.allSpeak=false;
          this.allProximity=true;
          this.allProximityLessMe=false
          $("#allProximity").prop('checked',true);
          $("#allSpeak").prop('checked',false);
          $("#allMute").prop('checked',false);
          $("#allProximityLessMe").prop('checked',false);   
        }

        if (room.microphone){
          let filter=room.microphone.filter((v)=>{
            return v==this._appData.instagramUser.uid;
          })
          if (filter.length>0 && room.voiceStatus==0){
            $("#allProximityLessMe").prop('checked',true);   
            $("#allProximity").prop('checked',false);
          }
        }

        if (this._appData.page=='meeting'){
          this._companyService.updateConferenceUsers(this._appData.room).get().then((snap)=>{
            let users=snap.data()
            for (let prop in users){
              let user=users[prop]
              let name=user.name;
              let idx=name.indexOf('@')
              let full_name=name.substring(0,idx)
              let uid= name.substring(idx+1)
              this.contacts.push({profile_picture:"https://liveplanet.app.br/assets/landingstyle/profile.png",full_name:full_name,uid:uid})
            }
    
          })
        }
        else{
/*          this.ref=this._companyService.getUserRefOnRoom(this._appData.room.id)
          this.ref.on("child_added", (snapshot, prevChildKey) =>{     
            let _user=snapshot.val();  
            if (room.microphone){
              let filter=room.microphone.filter((v)=>{
                return v==_user.uid;
              })
              if (filter.length>0){
                _user.microfone=true;
              }
            }     
            this.contacts.push(_user)
          });
          this.ref.on("child_removed", (snapshot, prevChildKey) =>{     
            let _user=snapshot.val();
            this.contacts=this.contacts.filter(val=>{
              val.uid!=_user.uid
            })
          }); */
        }
  

      }



    }
    public sendMessage(contact){
      $('#roomMediaControlModal').modal('hide');
      Swal.fire({
        title: 'Mensagem privada',
        text:'Escreva a mensagem para '+contact.full_name,
        input: 'text',
        inputAttributes: {
        autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'ENTRAR',
        showLoaderOnConfirm: true,
      }).then((result) => {
      if (result.value) {
      let subject =  'Mensagem para você';
      let text =result.value 
      let date=new Date();
      let time=date.getTime();
      let notification;
      notification={
          subject:subject,
          message:text,
          kind:'text',
          date:time
      }
      this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,contact,subject,text,'text','','')
      $('#roomMediaControlModal').modal("show");

      }
    })
    }
     
    public callLive(contact){
        $('#roomMediaControlModal').modal('hide');
        Swal.fire({
          title: 'Convite pra live',
          text:'Deseja convidar '+contact.full_name+' para entrar na sua live? Escreva um texto-convite.',
          input: 'text',
          inputAttributes: {
          autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'ENTRAR',
          showLoaderOnConfirm: true,
        }).then((result) => {
        if (result.value) {
        let subject =  'Convite para entrar na live';
        let text =result.value 
        let date=new Date();
        let time=date.getTime();
        let notification;
        notification={
            subject:subject,
            message:text,
            kind:'callToLive',
            date:time,
            link:this._appData.liveLink
        }
        this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,contact,subject,text,'callToLive',this._appData.liveLink,'')
        $('#roomMediaControlModal').modal("show");

        }
      })
    }
    public removeLive(contact){

    }
    public EmbedUrl(){
      var url=$('#inputEmbedUrl').val()
      if (!url){
        url=''
      }
      let date=new Date();
      let time=date.getTime();
      let notification={
        subject:'mudança de video',
        video:url,
        kind:'updateRoomVideo',
        room:this._appData.room.id,
        date:time
      }
      this._companyService.addVideoToRoomList(this._appData.room.id,url)

      this._companyService.addEventNotification(this._appData.event,notification)
      this._companyService.getRoom(this._appData.room.id).get().then(val=>{
              let room=val.data();
              room.video=url;
              this._companyService.updateRoom(room);
      })

    }
    public askInviteLink(){
            Swal.fire({
              title:"Precisamos do link de convite",
              imageUrl: '/assets/img/streamyard.png',
              text:"Com o link de convite você consegue chamar pessoas para entrar na live na lista a esquerda. Por favor preencha o link de convite abaixo.",
              showCancelButton: true,
              input: 'text',
              cancelButtonText:'SAIR',
              confirmButtonText: 'Salvar',
              showLoaderOnConfirm: true,
            }).then((result) => {
              if (result.value) {
                this._appData.liveLink=result.value;
                this.askForEmbed();
              }
              else{
                Swal.fire({title:'Erro',text:'Por favor digite uma url para ser usada para convidar eventuais usuarios a sua live.'}).then(val=>{
                  this.askInviteLink();

                })
              }
          })

    }
    public askForEmbed(){
      Swal.fire({
        title: 'Live passo 2:',
        text:'Agora clique em GO Live e escreva abaixo o link para embedar o sua live para ser vista no Liveparty',
        input: 'text',
        inputAttributes: {
        autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Fim',
        showLoaderOnConfirm: true,
      }).then((result) => {
      if (result.value) {
      let pass=result.value;
      let date=new Date();
      let time=date.getTime();
      let notification={
        subject:'mudança de video',
        video:pass,
        kind:'updateRoomVideo',
        room:this._appData.room.id,
        date:time
      }
      this._companyService.addEventNotification(this._appData.event,notification)
      this._companyService.getRoom(this._appData.room.id).get().then(val=>{
              let room=val.data();
              room.video=pass;
              this._companyService.updateRoom(room);
        })
        $('#roomMediaControlModal').modal("show");

      }
      else{
        $('#roomMediaControlModal').modal("show");
        Swal.fire({title:'Erro',text:'Por favor digite o link do video sendo transmitido em live pelo youtube'})
      }
    })

  }
    public Live(){
      window.open('https://streamyard.com/', '_blank');
      $('#roomMediaControlModal').modal('hide');
      Swal.fire({
        title:"Iniciando Live",
        text:"Abrimos o streamYard em nova janela para você configurar sua live. Uma vez nele clique em 'Enter BroadCast Studio' e em seguida no botão '+Invite'. Um link lhe será dado para por no campo abaixo:",
        imageUrl: '/assets/img/streamyard.png',
        showCancelButton: true,
        input: 'text',
        cancelButtonText:'SAIR',
        confirmButtonText: 'Salvar',
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this._appData.liveLink=result.value;
          this.askForEmbed();
        }
        else{
            this.askInviteLink();
        }
      })
    }

/*    public Live(){     
      let youtubekey=$('#youtubeKey').val()
      if (!youtubekey){
        Swal.fire({title:'Erro',text:'Você precisa de uma chave do youtube pra transmitir essa aula'})
        return;
      }
      if (this.api){  
        this.api.dispose();
      }
      let videoCall='vipl'+this._appData.instagramUser.room+'_'+'LIVE';
      let querySelector=document.querySelector('#meetControl')
      let tools=[];

      let domain = 'meet.jit.si';
/*      if (this._appData.event.jitsiServer){
        domain = this._appData.event.jitsiServer;
      }*/
  /*    const options = {
          roomName: videoCall,
          width: '100%',
          height: '100%',
          configOverwrite: { 
            disableDeepLinking: true, 
            prejoinPageEnabled: false,
            startWithAudioMuted:false,
            startWithVideoMuted:false
          },
          interfaceConfigOverwrite:{ 
            SHOW_JITSI_WATERMARK: false,
            JITSI_WATERMARK_LINK: 'https://liveparty.com.br',
            SHOW_WATERMARK_FOR_GUESTS: false,
            SHOW_BRAND_WATERMARK: false,
            APP_NAME: 'LIVEPARTY',
            TOOLBAR_BUTTONS: tools,            
          SETTINGS_SECTIONS: [ 'devices', 'language', 'moderator', 'profile'],
          MOBILE_DOWNLOAD_LINK_ANDROID: 'https://play.google.com/store/apps/details?id=com.coolkids',
          ANDROID_APP_PACKAGE: 'com.viplistas',
          NATIVE_APP_NAME: 'liveparty',
          enableCalendarIntegration: false,
          BRAND_WATERMARK_LINK: 'https://liveparty.com.br',
          DEFAULT_REMOTE_DISPLAY_NAME: this._appData.instagramUser.full_name,
          DEFAULT_LOCAL_DISPLAY_NAME: 'Eu',
        },
        userInfo: {
          displayName: this._appData.instagramUser.full_name
        },
        parentNode: querySelector


      };
      //        interfaceConfigOverwrite:{ MOBILE_APP_PROMO: false},

        options.interfaceConfigOverwrite.TOOLBAR_BUTTONS=[
          'fullscreen','camera','videobackgroundblur','desktop','microphone'
        ]
        options.configOverwrite.startWithVideoMuted= false
        this.api = new JitsiMeetExternalAPI(domain, options);
        this.api.executeCommand('setVideoQuality', 180);
        setTimeout(()=>{
          this.api.executeCommand('startRecording', {
            mode: 'stream', //recording mode, either `file` or `stream`.
            youtubeStreamKey: youtubekey, //the youtube stream key.
            shouldShare:true
          });
  
        },5000)
        return true;

    }

*/
    public ngOnDestroy() : any {
    }


}















// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/room-media-control/room-media-component.ts